export function extractDigits(input: string | undefined | null): string {
  return (input ?? '').replace(/\D/g, '');
}

export function formatPhone10Digits(input: string | undefined | null): string {
  const digits = extractDigits(input);

  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
